//      

                                             
                                         
import RootNodeProvider from "../helper/RootNodeProvider";
                                                          
import {createSlice} from "@reduxjs/toolkit";

                                  
                  
                  
                   
                    
                   
                 
                         
                                        
                            
                           
                        
                   
 

export const getConfig                           = () => {
	let config = {
		vehicle: null,
		dealerId: null,
		intent: null,
		fractionDigits: null,
		trackingProperties: {},
		useConsentManager: false,
		trackerLoaded: false,
		showMsrp: true,
	};
	if (RootNodeProvider.getUclRootNode()) {
		const {dealerid, brand = null, language = navigator.language, engine, hsn, tsn, model, series,
			currencycode = "EUR", price = "0", fin, storageid, intent, fractiondigits = "false",
			useConsentManager = false, disableMsrp} = RootNodeProvider.getUclRootNode().dataset;
		config = {
			vehicle: {
				brand,
				engine,
				mkn: hsn,
				tkn: tsn,
				model,
				series,
				vin: fin
			},
			intent,
			fractionDigits: fractiondigits,
			language,
			storageId: storageid,
			dealerId: dealerid,
			offerPrice: {
				currency: currencycode,
				value: parseInt(price)
			},
			trackingProperties: {},
			useConsentManager: !!useConsentManager,
			trackerLoaded: false,
			// data-disable-msrp hides the RRP everywhere (markets where advertising it is not permitted), see #55467
			showMsrp: disableMsrp === undefined,
		};
	}
	return config;
};

const initialState                     = getConfig();

const configSlice = createSlice({
	name: "config",
	initialState,
	reducers: {
		configSuccessGet(state,action) {
			state.trackingProperties = action.payload.configurationDetails.trackingProperties;
			state.manufacturerTitle = action.payload.dealerDetails.dealership.manufacturerTitle;
		},
		trackerLoaded(state,action) {
			state.trackerLoaded = action.payload;
		}
	}
});

export const {configSuccessGet, trackerLoaded} = configSlice.actions;
export default configSlice.reducer;
